import React from 'react';
import { LogoMark } from '../components/deck/LogoMark';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
import { productShots } from '../data/ecosystem';
import { logos } from '../data/logos';
const current = ['Dedicated portal for Canadian startup scouting', 'Structured company intake through DiligenceGPT™', 'Consistent evaluation — Sony decides independently'];
const expansion = [{
  name: 'Further startup scouting',
  detail: 'Additional markets and mandates'
}, {
  name: 'Multi-year licences',
  detail: 'Longer-term platform agreements'
}, {
  name: 'Expansion to global teams',
  detail: 'More teams and geographies'
}, {
  name: 'Reporting functionality',
  detail: 'Portfolio and internal reporting'
}];
export function SonyCaseStudySlide() {
  return <Slide index={9} source="Expansion opportunities represent potential next phases of the relationship and are not contracted revenue." data-id="element-501" data-mp="p4ij9nck9nyu">
      <div className="flex items-start justify-between gap-[3cqw]" data-id="element-502" data-mp="1rxf64ov2r9ad">
        <div className="max-w-[62%]" data-id="element-503" data-mp="1mz3wae4s4ys5">
          <Eyebrow data-id="element-504" data-mp="1my2kg7fxw89d">Customer expansion</Eyebrow>
          <Title className="mt-[2.2cqh]" data-id="element-505" data-mp="1mx9kpqfeej0q">
            Sony Innovation Fund: a paid enterprise engagement with room to
            expand.
          </Title>
        </div>
        <div className="flex h-[15cqh] w-[22cqw] items-center justify-center bg-white" data-id="element-506" data-mp="1wpfbwxxtswev">
          <LogoMark logo={logos.sony} maxW={30} maxH={11} data-id="element-507" data-mp="19046v49g0fux" />
        </div>
      </div>

      <div className="mt-auto grid grid-cols-[30%_27%_auto_1fr] items-stretch gap-[2cqw]" data-id="element-508" data-mp="1411eajang23u">
        <Reveal delay={0.08} className="flex min-h-0 flex-col" data-id="element-509" data-mp="1ixsegus5dhui">
          <span className="text-[clamp(8px,0.8cqw,17px)] tracking-[0.16em] text-[#3B8CFF]" data-id="element-510" data-mp="1iv5xk4jd9pzm">
            app.dgpt.io/p/sonyvc
          </span>
          <img src={productShots.pipelineTable} alt="DiligenceGPT dedicated Sony Innovation Fund portal pipeline view" className="mt-[1.2cqh] max-h-[34cqh] w-full border border-white/12 object-contain object-top" data-id="element-511" data-mp="2ubw45orpcjtr" />
        </Reveal>

        <Reveal delay={0.14} className="flex flex-col border border-[#2FBE8F]/35 bg-[#2FBE8F]/[0.06] p-[1.4cqw]" data-id="element-512" data-mp="31flzfftnmy9a">
          <span className="text-[clamp(7.5px,0.78cqw,16px)] uppercase tracking-[0.22em] text-[#2FBE8F]" data-id="element-513" data-mp="36ep4h09mx4h9">
            Current engagement · contracted
          </span>
          <p className="mt-[1.6cqh] text-[clamp(26px,3.1cqw,66px)] leading-none text-[#F4F7FC]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-514" data-mp="2dqb44dv2pw2j">
            $100K
          </p>
          <Caption className="mt-[0.8cqh]" data-id="element-515" data-mp="2noqw0j1xd9d3">Paid 12-month engagement</Caption>
          <ul className="mt-auto space-y-[1.2cqh] pt-[2cqh]" data-id="element-516" data-mp="2nme7fn1nw0r2">
            {current.map(c => <li key={c} className="text-[clamp(9.5px,1cqw,21px)] leading-snug text-[#DCE3EE]" data-id="element-517" data-mp="2sha6361elmd5">
                {c}
              </li>)}
          </ul>
        </Reveal>

        <div className="flex items-center text-[clamp(16px,1.8cqw,38px)] text-white/30" data-id="element-518" data-mp="1zx1xum2f9qo8">→</div>

        <Reveal delay={0.2} className="flex flex-col border border-dashed border-white/20 p-[1.4cqw]" data-id="element-519" data-mp="h38kou8xl4oi">
          <span className="text-[clamp(7.5px,0.78cqw,16px)] uppercase tracking-[0.22em] text-[#8B95A8]" data-id="element-520" data-mp="d2yd5d5hq67j">
            Expansion opportunities · potential
          </span>
          <div className="mt-auto grid grid-cols-2 gap-x-[1.8cqw] gap-y-[2.6cqh]" data-id="element-521" data-mp="32xrvlo29g0p">
            {expansion.map(e => <div key={e.name} className="border-t border-white/10 pt-[1.4cqh]" data-id="element-522" data-mp="3ubv3lqb9dceh">
                <p className="text-[clamp(12px,1.35cqw,28px)] leading-tight text-[#F4F7FC]" style={{
              fontFamily: 'var(--font-serif)'
            }} data-id="element-523" data-mp="3pis83cmx7svn">
                  {e.name}
                </p>
                <Caption className="mt-[0.8cqh]" data-id="element-524" data-mp="3ggst0pvguyvc">{e.detail}</Caption>
              </div>)}
          </div>
        </Reveal>
      </div>
    </Slide>;
}